import { render, staticRenderFns } from "./AssemblePackage.vue?vue&type=template&id=684c0a12&scoped=true"
import script from "./AssemblePackage.vue?vue&type=script&lang=js"
export * from "./AssemblePackage.vue?vue&type=script&lang=js"
import style0 from "./AssemblePackage.vue?vue&type=style&index=0&id=684c0a12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684c0a12",
  null
  
)

export default component.exports